export default {
  business_no: 'No. Negocio',
  business_name: 'Nombre Negocio',
  business_type: 'Tipo Negocio',
  select_business_type: 'Seleccionar Tipo',
  self_operated: 'Propio',
  franchise: 'Franquicia',
  business_region: 'Región',
  business_currency: 'Moneda',
  related_franchisee: 'Franquiciado',
  select_region: 'Seleccionar Región',
  select_currency: 'Seleccionar Moneda',
  select_franchisee: 'Seleccionar Franquiciado',
  description: 'Descripción',
  enter_description: 'Ingrese descripción',
  create_time: 'Fecha Creación',
  create_business: 'Crear Negocio',
  edit_business: 'Editar Negocio',
  business_detail: 'Detalle Negocio',
  create_success: 'Creado exitosamente',
  edit_success: 'Actualizado exitosamente',
  enter_business_name: 'Ingrese nombre negocio',
  franchisee_no: 'No. Franquiciado',
  franchisee_name: 'Nombre Franquiciado',
  region: 'Región',
  currency: 'Moneda',
  remark: 'Observación',
  enter_remark: 'Ingrese observación',
  contact_name: 'Nombre Contacto',
  enter_contact_name: 'Ingrese nombre contacto',
  contact_phone: 'Teléfono',
  enter_phone: 'Ingrese teléfono',
  contact_email: 'Correo',
  enter_email: 'Ingrese correo',
  create_franchisee: 'Crear Franquiciado',
  edit_franchisee: 'Editar Franquiciado',
  franchisee_detail: 'Detalle Franquiciado',
  confirm_submit: 'Confirmar Envío',
  confirm_franchisee: 'Confirme información del franquiciado',
  submit: 'Enviar',
  franchisee_create_success: 'Franquiciado creado exitosamente',
  franchisee_edit_success: 'Franquiciado actualizado exitosamente',
  enter_franchisee_name: 'Ingrese nombre franquiciado',
  select_business: 'Seleccionar Negocio',
  copy_success: 'Copiado exitosamente',
  business_no_export: 'No. Negocio',
  business_name_export: 'Nombre Negocio',
  franchisee_no_export: 'No. Franquiciado',
  franchisee_name_export: 'Nombre Franquiciado',
  business: 'Negocio',
  franchisee: 'Franquiciado'
}
